import gql from "graphql-tag";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const profileFields= `
id
profileUniqueId
userFirstName
userLastName
userEmail
profilePhone
profileTitle
profilePhoto
profileIsActive
profileIsDeactivated
userDesignation {
  id
  designationUniqueId
  designationShortForm
  designationName
}
role {
  id
  roleUniqueId
  roleName
  roleIsAdmin
  roleIsSystemDefault
  roleDescription
}
profileType`


export const popsmGgUserFields = `
id
adminProfile {
  ${profileFields}
}
adminRoles {
  id
  roleUniqueId
  roleName
  roleIsAdmin
  roleIsSystemDefault
  roleDescription
  rolePermissions {
    id
    permissionUniqueId
    permissionName
    permissionCode
  }
}
userDesignation {
  id
  designationUniqueId
  designationShortForm
  designationName
}
`

export const GET_SYSTEM_ADMINISTRATORS = gql`
  query GetSystemAdministrators($filtering: UserFilteringInputObject) {
    getSystemAdministrators(filtering: $filtering) {
     ${baseResponseGraphqlField}
      data {
        ${profileFields}
      }
    }
  }`

export const CREATE_POPSM_USER_MUTATION = gql`
  mutation CreatePopsmUserMutation($input: POPSMUserInputObject!) {
    createPopsmUserMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${popsmGgUserFields}
      }
    }
  }`

export const UPDATE_POPSM_USER_MUTATION = gql`
  mutation UpdatePopsmUserMutation($input: POPSMUserInputObject!) {
    updatePopsmUserMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${popsmGgUserFields}
      }
    }
  }`
